<template>
  <el-popover popper-class="wechat-popover" trigger="hover" placement="bottom">
    <template slot="reference"></template>
    <slot slot="reference"></slot>
    <div class="popover-wrapper">
      <YorkbbsImage class="popover-qrcode" width="90px" height="90px" :src="_weChatQrcode"></YorkbbsImage>
      <div class="popover-desc">
        <div class="popover-title">扫一扫 加微信</div>
        <div class="popover-id e" v-if="weChatId">微信号：{{ weChatId }}</div>
        <button
          class="popover-button__copy"
          v-clipboard:copy="weChatId"
          v-clipboard:success="() => $success('复制成功')"
          v-if="weChatId"
        >
          复制微信号
        </button>
      </div>
    </div>
  </el-popover>
</template>
<script>
import { webpFormat } from '@/utils/utils';
export default {
  name: 'PopoverWechat',
  props: {
    weChatId: String,
    weChatQrcode: String,
  },
  computed: {
    _weChatQrcode() {
      return this.weChatQrcode ? webpFormat(this.weChatQrcode, 100) : require('@/assets/images/house/qrcode_empty.png');
    },
  },
};
</script>
<style lang="scss" scoped>
.popover-wrapper {
  display: flex;
  align-items: center;
}
.popover-qrcode {
  margin-right: 16px;
}
.popover-desc {
  flex: 1;
  overflow: hidden;
  color: #fff;
}
.popover-title,
.popover-id {
  font-size: 14px;
  line-height: 25px;
}
.popover-button__copy {
  font-size: 12px;
  border: 1px solid #979797;
  border-radius: 4px;
  height: 22px;
  padding: 0 4px;
  margin-top: 8px;
}
</style>
<style lang="scss">
$bgcolor: rgba(
  $color: #000000,
  $alpha: 0.7,
);
.wechat-popover {
  width: 250px;
  background-color: $bgcolor;
  border: 0 none;
}
.wechat-popover[x-placement^='top'] .popper__arrow {
  bottom: -7px;
  &::after {
    border-top-color: $bgcolor;
  }
}
.wechat-popover[x-placement^='bottom'] .popper__arrow {
  top: -7px;
  &::after {
    border-bottom-color: $bgcolor;
  }
}
.wechat-popover[x-placement^='left'] .popper__arrow {
  right: -7px;
  &::after {
    border-left-color: $bgcolor;
  }
}
.wechat-popover[x-placement^='right'] .popper__arrow {
  left: -7px;
  &::after {
    border-right-color: $bgcolor;
  }
}
</style>
